import { chargesForMonth } from "./chargeDates";

const emailKey = (value) => String(value || "").trim().toLowerCase();

export const calculateAccountBalances = ({ records = [], payments = [], month }) => {
  // Historical charges are not replayed into the next month's opening balance.
  // Each statement period contains only charges and instalments due in that month.
  const balances = new Map();
  const openingBalanceEntries = new Map();

  const currentMovements = new Map();
  const currentCredits = new Map();
  const currentDebits = new Map();
  const addCurrent = (email, value) => {
    const key = emailKey(email);
    if (key) currentMovements.set(key, (currentMovements.get(key) || 0) + Number(value || 0));
  };
  const addCurrentCredit = (email, value) => {
    const key = emailKey(email);
    if (key) currentCredits.set(key, (currentCredits.get(key) || 0) + Number(value || 0));
  };
  const addCurrentDebit = (email, value) => {
    const key = emailKey(email);
    if (key) currentDebits.set(key, (currentDebits.get(key) || 0) + Number(value || 0));
  };
  chargesForMonth(records, month).forEach((record) => {
    if (record.excludeFromBalance === true) return;
    const charge = Number(record.amountCharged || 0);
    addCurrent(record.adviserEmail, -charge);
    addCurrentDebit(record.adviserEmail, charge);
  });
  const monthPayments = payments.filter((payment) => payment.paymentMonth === month);
  const manuallyUploadedOpeningBalances = new Set(
    monthPayments
      .filter(
        (payment) =>
          payment.paymentType === "opening_balance" &&
          payment.source !== "closing_balance_carry_forward",
      )
      .map((payment) => emailKey(payment.adviserEmail))
      .filter(Boolean),
  );
  monthPayments.forEach((payment) => {
    if (payment.paymentType === "opening_balance") {
      const key = emailKey(payment.adviserEmail);
      if (!key) return;
      if (
        payment.source === "closing_balance_carry_forward" &&
        manuallyUploadedOpeningBalances.has(key)
      ) {
        return;
      }
      const amount = Number(payment.openingBalanceAmount || 0);
      balances.set(key, (balances.get(key) || 0) + amount);
      const entries = openingBalanceEntries.get(key) || [];
      openingBalanceEntries.set(key, [
        ...entries,
        {
          month,
          amount,
          date: payment.date,
          description: payment.description || "Opening Balance brought forward",
          source: payment.source || "manual",
        },
      ]);
      return;
    }
    const paid = Number(payment.amountPaid || 0);
    const deducted = Number(payment.amountDeducted || 0);
    if (payment.paymentType === "additional_payment") {
      const additionalPayment = Math.abs(paid);
      addCurrent(payment.adviserEmail, additionalPayment);
      addCurrentCredit(payment.adviserEmail, additionalPayment);
      return;
    }
    addCurrent(payment.adviserEmail, paid - deducted);
    addCurrentCredit(payment.adviserEmail, paid);
    addCurrentDebit(payment.adviserEmail, deducted);
  });

  return {
    balances,
    openingBalanceEntries,
    currentMovements,
    currentCredits,
    currentDebits,
  };
};
